var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 13.8135C22 19.3365 17.523 23.8135 12 23.8135C6.477 23.8135 2 19.3365 2 13.8135C2 8.29148 6.477 3.81348 12 3.81348C17.523 3.81348 22 8.29148 22 13.8135Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71184 14.7574C8.71184 16.8439 10.0298 18.6206 11.8776 19.3052V19.8137C8.74747 19.6827 6.25 17.1044 6.25 13.9413C6.25 10.7782 8.74734 8.19964 11.8776 8.0687V10.2119C10.0296 10.8943 8.71184 12.6712 8.71184 14.7574Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9407 17.1419C14.6248 18.4582 12.4908 18.4582 11.1745 17.1419C10.0064 15.9729 9.87521 14.1615 10.7807 12.8476L12.3301 14.3967C12.5694 14.6369 12.9573 14.6369 13.1968 14.3967C13.4361 14.1566 13.4361 13.7692 13.1968 13.5291L11.6471 11.98C12.96 11.0756 14.7725 11.2056 15.9406 12.3746C17.2568 13.6909 17.2568 15.8257 15.9406 17.1419H15.9407ZM10.7413 11.9409C9.18586 13.4972 9.18586 16.0195 10.7413 17.5734C12.2968 19.1299 14.8186 19.1299 16.3742 17.5734C17.9297 16.0195 17.9297 13.4972 16.3742 11.9409C14.8188 10.3869 12.2968 10.3869 10.7413 11.9409Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeController);
export default __webpack_public_path__ + "static/media/volume_controller.a96ab9e8bdf501f81cd128364e7eca53.svg";
export { ForwardRef as ReactComponent };